import { Tab } from "@mui/material";
import { styled } from "@mui/material/styles";

export default styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: "700 !important",
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    "&.Mui-selected": {
      fontWeight: "700 !important",
      borderBottom: "3px solid black"
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
      fontWeight: "700 !important",
    },
  })
);
